import { render, staticRenderFns } from "./UserAccountManagerTab.vue?vue&type=template&id=53d540b7"
import script from "./UserAccountManagerTab.vue?vue&type=script&lang=js"
export * from "./UserAccountManagerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports